import { noAccents } from './mask'

/**
 * Coordenadas (lat, lng) das cidades cadastradas nos pacientes, para o mapa do dashboard.
 * Chave normalizada: minúsculas, sem acento, sem espaços nas pontas (ver geoCidade()).
 * Fonte: OpenStreetMap/Nominatim, coletado uma vez em 2026-09-14.
 * Para incluir uma cidade nova basta adicionar uma linha aqui.
 */
export const GEO_CIDADES: Record<string, [number, number]> = {
  'rolante': [-29.6528, -50.5769], // Rolante
  'riozinho': [-29.6405, -50.4596], // Riozinho
  'taquara': [-29.6452, -50.7832], // Taquara
  'santo antonio da patrulha': [-29.8268, -50.5175], // Santo Antônio da Patrulha
  'sapiranga': [-29.6392, -51.0069], // Sapiranga
  'tres coroas': [-29.5155, -50.7771], // Três Coroas
  'parobe': [-29.6243, -50.8312], // Parobé
  'novo hamburgo': [-29.6906, -51.1429], // Novo Hamburgo
  'porto alegre': [-30.0325, -51.2304], // Porto Alegre
  'canada': [61.0667, -107.9917], // Canada
  'ararica': [-29.6169, -50.9291], // Araricá
  'igrejinha': [-29.5693, -50.7919], // Igrejinha
  'sao francisco de paula': [-29.4485, -50.5833], // São Francisco de Paula
  'alegrete': [-29.7902, -55.7949], // Alegrete
  'alvorada': [-29.9981, -51.0773], // Alvorada
  'nova hartz': [-29.5842, -50.9043], // Nova Hartz
  'minas gerais': [-19.9227, -43.9451], // Belo Horizonte
  'campo bom': [-29.6784, -51.0572], // Campo Bom
  'bom principio': [-29.4898, -51.3567], // Bom Princípio
  'rio de janeiro': [-22.911, -43.2094], // Rio de Janeiro
  'sao leopoldo': [-29.7544, -51.1516], // São Leopoldo
  'caraa': [-29.7917, -50.434], // Caraá
  'gramado': [-29.3793, -50.8737], // Gramado
  'osorio': [-29.8891, -50.274], // Osório
  'eua': [39.7837, -100.4459], // United States
  'ariquemes': [-9.9077, -63.0331], // Ariquemes
  'rio da ilha (taquara)': [-29.6452, -50.7832], // Taquara
  'sao paulo': [-23.5507, -46.6334], // São Paulo
  'caraguatatuba': [-23.6203, -45.4131], // Caraguatatuba
  'inglaterra': [51.5074, -0.1278], // Greater London
  'canela': [-29.3447, -50.7604], // Canela
  'santo antonio': [-29.8268, -50.5175], // Santo Antônio da Patrulha
  'esteio': [-29.8512, -51.1779], // Esteio
  'sapucaia do sul': [-29.8197, -51.1609], // Sapucaia do Sul
  'cachoeirinha': [-29.9493, -51.0899], // Cachoeirinha
  'gravatai': [-29.944, -50.9931], // Gravataí
  'ivoti': [-29.5934, -51.1599], // Ivoti
  'dois irmaos': [-29.5836, -51.0898], // Dois Irmãos
  'morro reuter': [-29.539, -51.0819], // Morro Reuter
  'nova petropolis': [-29.376, -51.1123], // Nova Petrópolis
  'caxias do sul': [-29.1685, -51.1796], // Caxias do Sul
  'capao da canoa': [-29.7508, -50.0211], // Capão da Canoa
  'tramandai': [-29.9855, -50.1316], // Tramandaí
  'viamao': [-30.0819, -51.0262], // Viamão
  'canoas': [-29.9216, -51.18], // Canoas
  'estancia velha': [-29.653, -51.172], // Estância Velha
  'portao': [-29.6933, -51.2332], // Portão
  'maquine': [-29.6756, -50.2056], // Maquiné
  'terra de areia': [-29.5789, -50.0634], // Terra de Areia
}

export function normalizarCidade(cidade: string) {
  return noAccents(cidade || '')
    .toLowerCase()
    .trim()
    .replace(/\s+/g, ' ')
}

/** Retorna [lat, lng] da cidade ou undefined se não estiver cadastrada. */
export function geoCidade(cidade: string): [number, number] | undefined {
  return GEO_CIDADES[normalizarCidade(cidade)]
}
